
        var result = require("!!../../../../../node_modules/css-loader/index.js!./whitelabel-configs.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/whitelabels/whitelabel-configs/whitelabel-configs.component.css
// module id = 699
// module chunks = 0